import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-accessibility',
    templateUrl: './accessibility.component.html',
    styleUrls: ['./accessibility.component.css'],
    standalone: false
})
export class AccessibilityComponent implements OnInit {

  ngOnInit(): void {
    document.getElementsByTagName('mat-sidenav-content')[0]?.scrollTo(0, 0);
  }

}
